module.exports = __webpack_public_path__ + "img/magento-banner_small.7250963a.jpg";